import { useInitFoetalObservations } from "./useInitFoetalObservations";
import { useUpsertFoetalObservation } from "./useUpsertFoetalObservation";

export const useSaveFoetalObservations = ({
  consultationId,
  pregnancyId,
  foetuses,
  foetalObsValues,
  existingObservations,
}) => {
  const { mutateAsync: initFoetalObservations } = useInitFoetalObservations();
  const { mutate: upsertFoetalObservation } = useUpsertFoetalObservation(consultationId);

  const saveAll = async (resolvedConsultationId) => {
    if (foetuses.length === 0) return;

    const seeded =
      existingObservations && existingObservations.length > 0
        ? existingObservations
        : await initFoetalObservations({ consultationId: resolvedConsultationId, pregnancyId });

    const observations = Array.isArray(seeded) ? seeded : [];

    foetuses.forEach((foetus) => {
      const values = foetalObsValues[foetus.foetusIdentifier];
      if (!values) return;

      const existing = observations.find((o) => o.foetusId === foetus.id);

      upsertFoetalObservation({
        ...(existing?.id ? { id: existing.id } : {}),
        anteNatalConsultationId: resolvedConsultationId,
        foetusId: foetus.id,
        isActive: true,
        presentation: values.presentation || null,
        engagement: values.engagement || null,
        heartHeardWithDoppler: values.heartHeardWithDoppler || null,
        activity: values.activity || null,
        heartRateBpm: values.heartRateBpm ? parseInt(values.heartRateBpm, 10) : null,
        estimatedWeightGrams: values.estimatedWeightGrams
          ? parseInt(values.estimatedWeightGrams, 10)
          : null,
        notes: values.notes || null,
      });
    });
  };

  return { saveAll };
};
